import React from 'react';
import {AgendaComponentWrapper} from './styles/AgendaComponent-style';



function AgendaComponent(props) {
    const agenda = props.agenda;
    const meetingName = props.meetingName;

    return (
        <AgendaComponentWrapper className='AgendaCompoent'>

            <div className="meetingName">
                <p>Meeting: {meetingName}</p>
            </div>
            <div className="header">
                <p>Agenda Items</p>
            </div>
            <div className="Agenda List">
                <ul>
                {agenda.map(agenda => (
                <li>{agenda}</li>
                ))}
                </ul>
            </div>
        </AgendaComponentWrapper>
    );
}

export default AgendaComponent